// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB9-mOpOROKS_VIOYaiz1iGt4eqTAWTDwk",
  authDomain: "kbl-login.firebaseapp.com",
  projectId: "kbl-login",
  storageBucket: "kbl-login.appspot.com",
  messagingSenderId: "550005795777",
  appId: "1:550005795777:web:9d6b58c7f3a1faa7179d40",
  measurementId: "G-M884L71RRY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
getAnalytics(app);
const auth = getAuth();
const db = getFirestore();

export { auth, db };

// Firebase Exports
// export const db = getFirestore();
// export const auth = getAuth();
